import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Radio from '@material-ui/core/Radio';
import CrcDialog from '../../../modules/checkListGenerator/crcChecklist/crcChecklistAddRelevancePopUp';
import CRSalaryDifference from './salary';
import CRCHouseproperty from './houseproperty';
import CRCBusiness from './business';
import CRCCapitalgain from './capitalgain';
import CRCOthersources from './othersources';
import CRCAgricultureIncome from './agricultureincome';
import CRCDonations from './donations';
import { CommonConfig } from '../../../config/common-config';
import { userType } from '../../../config/usertypeValue';
// import { LocalConvenienceStoreOutlined } from '@material-ui/icons';
import LoaderPopUp from '../../../components/loaderpopup/loader';
import { cacheservice } from '../../../config/cacheservice';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(1),
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: '25ch',
    },
    bottomLine: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    button: {
        margin: '10px 0px 5px !important',
        width: '155px',
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
    },
    checked: {},
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 10px 0px 0px',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    expenditure: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    adornedEnd: {
        width: '20px',
        marginLeft: '300px',
        fontSize: '8px',
        height: '17px',
    },
    relevanceIndicator: {
        color: '#f9f9f9',
        backgroundColor: '#3ccbcb',
        paddingTop: '5px',
        paddingRight: '40px',
        paddingBottom: '5px',
        paddingLeft: '40px',
        fontFamily: 'Rubik',
    },

    irrelevanceIndicator: {
        color: '#f9f9f9',
        backgroundColor: '#db466b',
        paddingTop: '5px',
        paddingRight: '40px',
        paddingBottom: '5px',
        paddingLeft: '40px',
        fontFamily: 'Rubik',
    },

    partrelevanceIndicator: {
        color: '#f9f9f9',
        backgroundColor: ' #FFC300',
        paddingTop: '5px',
        paddingRight: '40px',
        paddingBottom: '5px',
        paddingLeft: '40px',
        fontFamily: 'Rubik',
    },
    btnFieldPositionRight: {
        position: 'absolute',
        right: '0',
        top: '12px',
    },
    selectView: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
        fontSize: '14px',
        paddingTop: '15px',
        '& .MuiSelect-icon': {
            // display: 'none',
            // right: '50%',
        },
    },
}));
function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}

export default function CrcDifferentSource(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [apiResponse, setApiResponse] = React.useState('');
    const [itecOpen, setItecOpen] = React.useState(false);
    const [CRCItem, setCrcItem] = React.useState('');
    const [CRCUpdateIndex, setCRCUpdateIndex] = React.useState(0);
    const [TabName, setTabName] = React.useState('');
    const [subTabName, setsubTabName] = React.useState('');
    const [category, setcategory] = React.useState('');
    const [remarks, setremarks] = React.useState('');
    const [relevanceCat, setRelevanceCat] = React.useState('');
    const [formValues, setformValues] = React.useState({
        nameEmployer: 'Enter Employer',
        investment: 'Enter Investments',
        investmentAmt: 'Enter Amount',
        donationDetails: 'Enter Donation details',
        donationAmt: 'Enter Amount',
    });

    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const dbname = tennantDetails && tennantDetails.tennantName;
    const userTypeValue = userDetails.result && userDetails.result.data.features[0].branchName;
    const imcNameSelected = useSelector((state) => state.serviceCheckListReducer.imcNameSelected);
    const usertype = userDetails.result && userDetails.result.data.features[5].branchName;
    const [checklist, setChecklist] = useState('');
    const checklistValues = checklist.checklistJson;
    const checklist1 = checklistValues && checklistValues.checklistL1;
    const checklist1que = checklist1 && checklist1.questions;
    const salaryradiodata = (checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[0].fields[0].response) || 'Yes';
    const stageId = useSelector((state) => state.serviceCheckListReducer.selectedStageId);
    const [showLoader, setShowLoader] = useState(false);

    const handleItecClose = () => {
        setTimeout(() => {
            setItecOpen(false);
        }, 1000);
    };
    const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);

    useEffect(() => {
        setApiResponse(props.apiResponse);
        if (props.apiResponse) {
            let iniVal = {
                // nameEmployer: props.apiResponse[0].fields[0].response != null ? props.apiResponse[0].fields[0].response : 'Enter Employer',
                // investment: props.apiResponse[0].fields[1].response != null ? props.apiResponse[0].fields[1].response : 'Enter Investments',
                // investmentAmt: props.apiResponse[0].fields[2].response != null ? props.apiResponse[0].fields[2].response : 'Enter Amount',
                // donationDetails:
                //     props.apiResponse[0].fields[3].response != null ? props.apiResponse[0].fields[3].response : 'Enter Donation details',
                // donationAmt: props.apiResponse[0].fields[4].response != null ? props.apiResponse[0].fields[4].response : 'Enter Amount',
            };
            setformValues(iniVal);
        }

        const bearerToken = `Bearer ${userToken}`;

        // console.log('userType.historyStageId, stageId', userType.historyStageId, stageId)
        if (userType.historyStageId <= stageId) {
            // console.log('history view')
            if (userTypeValue === 'ITeC AM and above' && userType.value === 'L1 AM Confirmed') {
                axios
                    .get(
                        `${CommonConfig.dev.baseUrl1}/api/itr/checklist-by-serviceId/${
                            usertype === 'Ultimate Client' || usertype === 'EM' ? dbname : imcNameSelected
                        }/${serviceIdValue}`,
                        {
                            headers: {
                                Authorization: bearerToken,
                            },
                        }
                    )
                    .then((response) => {
                        setApiResponse(response.data);
                        setChecklist(response.data);
                    })
                    .catch((error) => {});
            } else {
                axios
                    .get(
                        `${CommonConfig.dev.baseUrl1}/api/itr/itrhistory-by-serviceIdandstageId/${
                            usertype === 'Ultimate Client' || usertype === 'EM' ? dbname : imcNameSelected
                        }/${serviceIdValue}/${userType.historyStageId}`,
                        {
                            headers: {
                                Authorization: bearerToken,
                            },
                        }
                    )
                    .then((response) => {
                        let tempObj = response.data;
                        tempObj['checklistJson'] = JSON.parse(response.data.checklistJson);
                        //console.log('JSON.parse(response.data)', tempObj)
                        setApiResponse(tempObj);
                        setChecklist(tempObj);
                    })
                    .catch((error) => {});
            }
        } else {
            // console.log('active view')
            axios
                .get(
                    `${CommonConfig.dev.baseUrl1}/api/itr/checklist-by-serviceId/${
                        usertype === 'Ultimate Client' || usertype === 'EM' ? dbname : imcNameSelected
                    }/${serviceIdValue}`,
                    {
                        headers: {
                            Authorization: bearerToken,
                        },
                    }
                )
                .then((response) => {
                    setApiResponse(response.data);
                    setChecklist(response.data);
                })
                .catch((error) => {});
        }
        cacheservice.getCRCView().subscribe(() => {
            setTimeout(() => {
                handleTabChange('salary');
                userType.salaryInitializeFlag = true;
            }, 100);
        });
    }, [props]);

    const handleChange = (event, newValue) => {
        setTimeout(() => {
            setValue(newValue);
        }, 100);
    };

    const handleRelevence = (TabName, subTabName, index, name, item) => {
        // console.log('3rd screen ADD Revelence', TabName, subTabName, index, name, item, userType)
        setcategory(item.relevanceResponseCRC);
        setremarks(item.relevanceRemarksCRC);
        setRelevanceCat(name);
        setCrcItem(item);
        setTabName(TabName);
        setsubTabName(subTabName);
        setCRCUpdateIndex(index);
        setTimeout(() => {
            setItecOpen(true);
        }, 2000);
    };

    const updateCRCRelevance = (category, remarks) => {
        // setShowLoader(true);

        // console.log('category, remarks', category, remarks)
        let data = props.apiData;
        if (TabName === 'salary') {
            if (subTabName === 'SalaryTab') {
                CRCItem.relevanceRemarksCRC = remarks;
                CRCItem.relevanceResponseCRC = category;
                apiResponse.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[0].fields[CRCUpdateIndex] = CRCItem;
            }
            if (subTabName === 'investment') {
                CRCItem.relevanceRemarksCRC = remarks;
                CRCItem.relevanceResponseCRC = category;
                apiResponse.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[1].fields[CRCUpdateIndex] = CRCItem;
            }
            if (subTabName === 'donation') {
                CRCItem.relevanceRemarksCRC = remarks;
                CRCItem.relevanceResponseCRC = category;
                apiResponse.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[2].fields[CRCUpdateIndex] = CRCItem;
            }
        }
        if (TabName === 'houseProperty') {
            CRCItem.relevanceRemarksCRC = remarks;
            CRCItem.relevanceResponseCRC = category;
            if (subTabName === 'houseAddress') {
                apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[CRCUpdateIndex * 14] = CRCItem;
            }
            if (subTabName === 'rentRecieved') {
                apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[CRCUpdateIndex * 14 + 2] = CRCItem;
            }
            if (subTabName === 'propertyTaxPaid') {
                apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[CRCUpdateIndex * 14 + 3] = CRCItem;
            }
            if (subTabName === 'tenantName') {
                apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[CRCUpdateIndex * 14 + 4] = CRCItem;
            }
            if (subTabName === 'pan') {
                apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[CRCUpdateIndex * 14 + 5] = CRCItem;
            }
            if (subTabName === 'coowner') {
                for (let i = 0; i < apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].subSubQuestions.length; i++) {
                    if (
                        CRCItem.sectionText ===
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].subSubQuestions[i].sectionText
                    ) {
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].subSubQuestions[i] = CRCItem;
                    }
                }
            }
            if (subTabName === 'loanUpload') {
                apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[CRCUpdateIndex * 14 + 12] = CRCItem;
            }
            if (subTabName === 'TDSUpload') {
                apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[CRCUpdateIndex * 14 + 13] = CRCItem;
            }
        }
        if (TabName === 'business') {
            CRCItem.relevanceRemarksCRC = remarks;
            CRCItem.relevanceResponseCRC = category;
            if (subTabName === 'businessOrProfession') {
                apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[CRCUpdateIndex] = CRCItem;
            }
            if (subTabName === 'TallyYes') {
                apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[CRCUpdateIndex] = CRCItem;
            }
        }
        if (TabName === 'capitalGain') {
            CRCItem.relevanceRemarksCRC = remarks;
            CRCItem.relevanceResponseCRC = category;
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[3].fields[CRCUpdateIndex] = CRCItem;
        }
        if (TabName === 'otherTab') {
            if (subTabName === 'divident') {
                CRCItem.relevanceRemarksCRC = remarks;
                CRCItem.relevanceResponseCRC = category;
                apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[0].fields[CRCUpdateIndex] = CRCItem;
            }
            if (subTabName === 'fd') {
                CRCItem.relevanceRemarksCRC = remarks;
                CRCItem.relevanceResponseCRC = category;
                apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[1].fields[CRCUpdateIndex] = CRCItem;
            }
            if (subTabName === 'othersources') {
                CRCItem.relevanceRemarksCRC = remarks;
                CRCItem.relevanceResponseCRC = category;
                apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[2].fields[CRCUpdateIndex] = CRCItem;
            }
        }
        if (TabName === 'agricultureIncome') {
            //console.log('Item ', CRCItem);
            if (subTabName === 'agricultureName') {
                CRCItem.relevanceRemarksCRC = remarks;
                CRCItem.relevanceResponseCRC = category;
                apiResponse.checklistJson.checklistL1.questions[2].subQuestion[5].fields[CRCUpdateIndex] = CRCItem;
            }
            if (subTabName === 'agriAmount') {
                CRCItem.relevanceRemarksCRC = remarks;
                CRCItem.relevanceResponseCRC = category;
                apiResponse.checklistJson.checklistL1.questions[2].subQuestion[5].fields[CRCUpdateIndex] = CRCItem;
            }
            if (subTabName === 'agriReceipt') {
                CRCItem.relevanceRemarksCRC = remarks;
                CRCItem.relevanceResponseCRC = category;
                apiResponse.checklistJson.checklistL1.questions[2].subQuestion[5].fields[CRCUpdateIndex] = CRCItem;
            }
            if (subTabName === 'agriExpenses') {
                CRCItem.relevanceRemarksCRC = remarks;
                CRCItem.relevanceResponseCRC = category;
                apiResponse.checklistJson.checklistL1.questions[2].subQuestion[5].fields[CRCUpdateIndex] = CRCItem;
            }
        }
        if (TabName === 'donations') {
            if (subTabName === 'investment') {
                CRCItem.relevanceRemarksCRC = remarks;
                CRCItem.relevanceResponseCRC = category;
                apiResponse.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[0].fields[CRCUpdateIndex] = CRCItem;
            }
            if (subTabName === 'donation') {
                CRCItem.relevanceRemarksCRC = remarks;
                CRCItem.relevanceResponseCRC = category;
                apiResponse.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[1].fields[CRCUpdateIndex] = CRCItem;
            }
        }
        //console.log('apiResponse:', apiResponse);
        //in case of making API call with saga call createAPCallData(); which will create TempPayload
        //need all screen data at tempPayload.
        //and then send that tempPayLoad to dispatch(createGenInfoRequestSave({ params: TempPayLoad, bearerToken, serviceIdValue: serviceIdValue, usertype })); for api call;
        // createAPCallData();
        // setApiResponse(apiResponse);
        // dispatch(createGenInfoRequestSave({ params: TempPayLoad, bearerToken, serviceIdValue: serviceIdValue, usertype }));
        //make API call with out saga in case of success response update setAPIRespnse.
        // setTimeout(() => {
        //     // setItecOpen(false);

        // }, 1000);
        // setItecOpen(false);
        submitData();

        // setTimeout(() => {
        //     setShowLoader(false);
        // }, 10000);
    };

    const submitData = () => {
        // console.log('3rd screen Save Relevence', apiResponse);

        if (userTypeValue === 'ITeC AM and above' && userType.value === 'L1 AM Confirmed') {
            axios
                .put(
                    `${CommonConfig.dev.baseUrl1}/api/itr/checklist/am-save-relevance/${
                        usertype === 'Ultimate Client' || usertype === 'EM' ? dbname : imcNameSelected
                    }`,
                    { serviceId: serviceIdValue, checklistJson: apiResponse.checklistJson },
                    {
                        headers: {
                            Authorization: bearerToken,
                        },
                    }
                )
                .then((response) => {
                    // console.log('response472:', response);
                    // setTimeout(() => {
                    userType.salaryInitializeFlag = false;
                    userType.houseInitializeFlag = false;
                    userType.businessInitializeFlag = false;
                    userType.capitalInitializeFlag = false;
                    userType.otherInitializeFlag = false;
                    userType.agricultureInitializeFlag = false;
                    userType.donationInitializeFlag = false;
                    // console.log('userTypeuserType', userType)
                    // }, 500);
                    setTimeout(() => {
                        setItecOpen(false);
                    }, 2000);
                    props.onChange(!props.apicallFlag, props.panelID);
                    setApiResponse(apiResponse);
                })
                .catch((error) => {
                    setTimeout(() => {
                        setItecOpen(false);
                    }, 2000);
                });
        } else {
            axios
                .put(
                    `${CommonConfig.dev.baseUrl1}/api/itr/checklist/crc-save-relevance/${
                        usertype === 'Ultimate Client' || usertype === 'EM' ? dbname : imcNameSelected
                    }`,
                    { serviceId: serviceIdValue, checklistJson: apiResponse.checklistJson },
                    {
                        headers: {
                            Authorization: bearerToken,
                        },
                    }
                )
                .then((response) => {
                    // console.log('response492:', response);
                    // setTimeout(() => {
                    userType.salaryInitializeFlag = false;
                    userType.houseInitializeFlag = false;
                    userType.businessInitializeFlag = false;
                    userType.capitalInitializeFlag = false;
                    userType.otherInitializeFlag = false;
                    userType.agricultureInitializeFlag = false;
                    userType.donationInitializeFlag = false;
                    // console.log('userTypeuserType', userType)
                    // }, 500);
                    props.onChange(!props.apicallFlag, props.panelID);
                    setApiResponse(apiResponse);
                    setTimeout(() => {
                        setItecOpen(false);
                    }, 2000);
                })
                .catch((error) => {
                    setTimeout(() => {
                        setItecOpen(false);
                    }, 2000);
                });
        }
    };
    let TempPayLoad = {};
    const createAPCallData = () => {
        //creating payLoad for third screen tab one
        TempPayLoad.nameEmployer = apiResponse.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[0].fields[1].response;
        TempPayLoad.nameEmployerCRCrelevenceResponse =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[0].fields[1].relevanceResponseCRC;
        TempPayLoad.nameEmployerCRCrelevenceRemarks =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[0].fields[1].relevanceRemarksCRC;
        TempPayLoad.salaryradiodata =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[1].fields[0].response;
        // TempPayLoad.url =
        //     apiResponse.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[1].fields[2].response;
        let investmentArr = [];
        if (
            apiResponse.checklistJson.checklistL1 &&
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[1].fields.length > 0
        ) {
            for (
                let i = 0;
                i < apiResponse.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[1].fields.length;
                i += 2
            ) {
                let investmentArrtemp = {
                    investmentDetails:
                        apiResponse.checklistJson.checklistL1 &&
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[1].fields[i].response,
                    investmentDetailsCRCRelevenceResponse:
                        apiResponse.checklistJson.checklistL1 &&
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[1].fields[i].relevanceResponseCRC,
                    investmentDetailsCRCRelevenceRemarks:
                        apiResponse.checklistJson.checklistL1 &&
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[1].fields[i].relevanceRemarksCRC,
                    investmentAmt:
                        apiResponse.checklistJson.checklistL1 &&
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[1].fields[i + 1].response,
                    investmentAmtCRCRelevenceResponse:
                        apiResponse.checklistJson.checklistL1 &&
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[1].fields[i + 1]
                            .relevanceResponseCRC,
                    investmentAmtCRCRelevenceRemarks:
                        apiResponse.checklistJson.checklistL1 &&
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[1].fields[i + 1]
                            .relevanceRemarksCRC,
                };
                investmentArr.push(investmentArrtemp);
            }
        } else {
            let investmentArrtemp = {
                investmentDetails: '',
                investmentAmt: '',
            };
            investmentArr.push(investmentArrtemp);
        }
        TempPayLoad.investment = investmentArr;

        let donationArr = [];
        if (
            apiResponse.checklistJson.checklistL1 &&
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[2].fields.length > 0
        ) {
            for (
                let i = 0;
                i < apiResponse.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[2].fields.length;
                i += 2
            ) {
                let donationArrtemp = {
                    donationDetails:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[2].fields[i].response,
                    donationDetailsCRCRelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[2].fields[i].relevanceResponseCRC,
                    donationDetailsCRCRelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[2].fields[i].relevanceRemarksCRC,
                    donationAmt:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[2].fields[i + 1].response,
                    donationDetailsCRCRelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[2].fields[i + 1]
                            .relevanceResponseCRC,
                    donationDetailsCRCRelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[0].subSubQuestions[2].fields[i + 1]
                            .relevanceRemarksCRC,
                };
                donationArr.push(donationArrtemp);
            }
        } else {
            let donationArrtemp = {
                donationDetails: '',
                donationAmt: '',
            };
            donationArr.push(donationArrtemp);
        }
        TempPayLoad.donation = donationArr;

        //creating payload for third screen 2nd tab
        let housepropertyArr = [];
        if (apiResponse.checklistJson.checklistL1 && apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields.length > 0) {
            for (let i = 0; i < apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields.length; i += 14) {
                // let coownerArr = [];
                let housepropertyArrtemp = {
                    houseAddress: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i].response,
                    houseAddressCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i].relevanceResponseCRC,
                    houseAddressCRCrelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i].relevanceRemarksCRC,

                    houseStatusType: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 1].response,
                    houseStatusTypeCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 1].relevanceResponseCRC,
                    houseStatusTypeCRCrelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 1].relevanceRemarksCRC,

                    rent: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 2].response,
                    rentCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 2].relevanceResponseCRC,
                    rentCRCrelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 2].relevanceRemarksCRC,

                    propTax: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 3].response,
                    propTaxCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 3].relevanceResponseCRC,
                    propTaxCRCrelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 3].relevanceRemarksCRC,

                    tenantName: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 4].response,
                    tenantNameCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 4].relevanceResponseCRC,
                    tenantNameCRCrelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 4].relevanceRemarksCRC,

                    pan: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 5].response,
                    panCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 5].relevanceResponseCRC,
                    panCRCrelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 5].relevanceRemarksCRC,

                    housepurposeType: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 6].response,
                    housepurposeTypeCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 6].relevanceResponseCRC,
                    housepurposeTypeCRCrelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 6].relevanceRemarksCRC,

                    propertyCoOwnedType: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 11].response,
                    propertyCoOwnedTypeCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 11].relevanceResponseCRC,
                    propertyCoOwnedTypeCRCrelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 11].relevanceRemarksCRC,

                    haveyoutakenanyhousingloanType:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 9].response,
                    haveyoutakenanyhousingloanTypeCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 9].relevanceResponseCRC,
                    haveyoutakenanyhousingloanTypeCRCrelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 9].relevanceRemarksCRC,
                    rentUpload: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 7].response,

                    loanUpload: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 12].response,
                    loanUploadCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 12].relevanceResponseCRC,
                    loanUploadCRCrelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 12].relevanceRemarksCRC,

                    TDSUpload: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 13].response,
                    TDSUploadCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 13].relevanceResponseCRC,
                    TDSUploadCRCrelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 13].relevanceRemarksCRC,

                    uploadCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 7].relevanceResponseCRC,
                    uploadCRCrelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 7].relevanceRemarksCRC,
                    TDSdeductedinrentType: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 10].response,
                    TDSdeductedinrentTypeCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 10].relevanceResponseCRC,
                    TDSdeductedinrentTypeCRCrelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 10].relevanceRemarksCRC,
                    propertyUpload: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[i + 9].response,
                    coowner: [],
                };
                if (apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].subSubQuestions.length > 0) {
                    let coOwnerList = [];
                    for (let j = 0; j < apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].subSubQuestions.length; j += 3) {
                        if (
                            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].subSubQuestions[j].sectionText
                                .split('-')
                                .pop() == housepropertyArr.length
                        ) {
                            let coOwner = {
                                coownerName: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].subSubQuestions[j].response,
                                coownerNameCRCrelevenceResponse:
                                    apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[j].relevanceResponseCRC,
                                coownerNameCRCrelevenceRemarks:
                                    apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[j].relevanceRemarksCRC,
                                coownerPan:
                                    apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].subSubQuestions[j + 1].response,
                                coownerPanCRCrelevenceResponse:
                                    apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[j + 1].relevanceResponseCRC,
                                coownerPanCRCrelevenceRemarks:
                                    apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[j + 1].relevanceRemarksCRC,
                                share: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].subSubQuestions[j + 2].response,
                                shareCRCrelevenceResponse:
                                    apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[j + 2].relevanceResponseCRC,
                                shareCRCrelevenceRemarks:
                                    apiResponse.checklistJson.checklistL1.questions[2].subQuestion[1].fields[j + 2].relevanceRemarksCRC,
                            };
                            coOwnerList.push(coOwner);
                        }
                    }
                    housepropertyArrtemp.coowner = coOwnerList;
                }
                housepropertyArr.push(housepropertyArrtemp);
            }
        } else {
            let housepropertyArrtemp = {
                houseAddress: '',
                houseStatusType: '',
                rent: '',
                propTax: '',
                tenantName: '',
                pan: '',
                housepurposeType: '',
                propertyCoOwnedType: '',
                coowner: [
                    {
                        coownerName: '',
                        coownerPan: '',
                        share: '',
                    },
                ],
                haveyoutakenanyhousingloanType: '',
                rentUpload: '',
                TDSdeductedinrentType: '',
                propertyUpload: '',
                loanUpload: '',
                TDSUpload: '',
            };
            housepropertyArr.push(housepropertyArrtemp);
        }
        TempPayLoad.houseproperty = housepropertyArr;

        //creating payload for third screen 3rd tab
        TempPayLoad.natureBusiness =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[0].response;
        TempPayLoad.natureBusinessCRCrelevenceResponse =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[0].relevanceResponseCRC;
        TempPayLoad.natureBusinessCRCrelevenceRemarks =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[0].relevanceRemarksCRC;
        TempPayLoad.busProfincomeType =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[1].response;
        TempPayLoad.busProfincomeTypeCRCrelevenceResponse =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[1].relevanceResponseCRC;
        TempPayLoad.busProfincomeTypeCRCrelevenceRemarks =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[1].relevanceRemarksCRC;
        TempPayLoad.totalReceipts = apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[2].response;
        TempPayLoad.totalReceiptsCRCrelevenceResponse =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[2].relevanceResponseCRC;
        TempPayLoad.totalReceiptsCRCrelevenceRemarks =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[2].relevanceRemarksCRC;
        TempPayLoad.totalExpenses = apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[3].response;
        TempPayLoad.totalExpensesCRCrelevenceResponse =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[3].relevanceResponseCRC;
        TempPayLoad.totalExpensesCRCrelevenceRemarks =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[3].relevanceRemarksCRC;
        TempPayLoad.gstReturnDoc = apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[4].response;
        TempPayLoad.gstReturnDocCRCrelevenceResponse =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[4].relevanceResponseCRC;
        TempPayLoad.gstReturnDocCRCrelevenceRemarks =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[4].relevanceRemarksCRC;
        TempPayLoad.otherStatement =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[5].response;
        TempPayLoad.gstReturnDocCRCrelevenceResponse =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[5].relevanceResponseCRC;
        TempPayLoad.gstReturnDocCRCrelevenceRemarks =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[5].relevanceRemarksCRC;
        TempPayLoad.busProfType = apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[6].response;
        TempPayLoad.busProfTypeCRCrelevenceResponse =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[6].relevanceResponseCRC;
        TempPayLoad.busProfTypeCRCrelevenceRemarks =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[6].relevanceRemarksCRC;
        TempPayLoad.userIDtally = apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[7].response;
        TempPayLoad.userIDtallyCRCrelevenceResponse =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[7].relevanceResponseCRC;
        TempPayLoad.userIDtallyCRCrelevenceRemarks =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[7].relevanceRemarksCRC;
        TempPayLoad.passwordtally = apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[8].response;
        TempPayLoad.passwordtallyCRCrelevenceResponse =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[8].relevanceResponseCRC;
        TempPayLoad.passwordtallyCRCrelevenceRemarks =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[8].relevanceRemarksCRC;
        TempPayLoad.uploadTally = apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[9].response;
        TempPayLoad.uploadTallyCRCrelevenceResponse =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[9].relevanceResponseCRC;
        TempPayLoad.uploadTallyCRCrelevenceRemarks =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[9].relevanceRemarksCRC;

        TempPayLoad.userIDZoho = apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[10].response;
        TempPayLoad.userIDZohoCRCrelevenceResponse =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[10].relevanceResponseCRC;
        TempPayLoad.userIDZohoCRCrelevenceRemarks =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[10].relevanceRemarksCRC;

        TempPayLoad.passwordZoho = apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[11].response;
        TempPayLoad.passwordZohoCRCrelevenceResponse =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[11].relevanceResponseCRC;
        TempPayLoad.passwordZohoCRCrelevenceRemarks =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[11].relevanceRemarksCRC;

        TempPayLoad.userIDQB = apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[18].response;
        TempPayLoad.userIDQBCRCrelevenceResponse =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[18].relevanceResponseCRC;
        TempPayLoad.userIDQBCRCrelevenceRemarks =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[18].relevanceRemarksCRC;

        TempPayLoad.passwordQB = apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[19].response;
        TempPayLoad.passwordQBCRCrelevenceResponse =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[19].relevanceResponseCRC;
        TempPayLoad.passwordQBCRCrelevenceRemarks =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[19].relevanceRemarksCRC;

        TempPayLoad.accountDetails =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[12].response;
        TempPayLoad.accountDetailsCRCrelevenceResponse =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[12].relevanceResponseCRC;
        TempPayLoad.accountDetailsCRCrelevenceRemarks =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[12].relevanceRemarksCRC;
        TempPayLoad.partnershipradio =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[13].response;
        TempPayLoad.partnershipradioCRCrelevenceResponse =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[13].relevanceResponseCRC;
        TempPayLoad.partnershipradioCRCrelevenceRemarks =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[0].fields[13].relevanceRemarksCRC;
        let tallyYesArr = [];
        if (
            apiResponse.checklistJson.checklistL1 &&
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields.length > 0
        ) {
            for (
                let i = 0;
                i < apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields.length;
                i += 9
            ) {
                ////console.log('Hema.....', apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i]);
                let tallyYesArrtemp = {
                    nameFirm: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i].response,
                    nameFirmCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i].relevanceResponseCRC,
                    nameFirmCRCrelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i].relevanceRemarksCRC,
                    panNoFirm: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i + 1].response,
                    panNoFirmCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i + 1]
                            .relevanceResponseCRC,
                    panNoFirmCRCrelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i + 1]
                            .relevanceRemarksCRC,
                    remunRec: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i + 2].response,
                    remunRecCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i + 2]
                            .relevanceResponseCRC,
                    remunRecCRCrelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i + 2]
                            .relevanceRemarksCRC,
                    amtInt: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i + 3].response,
                    amtIntCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i + 3]
                            .relevanceResponseCRC,
                    amtIntCRCrelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i + 3]
                            .relevanceRemarksCRC,
                    shareProfit:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i + 4].response,
                    shareProfitCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i + 4]
                            .relevanceResponseCRC,
                    shareProfitCRCrelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i + 4]
                            .relevanceRemarksCRC,
                    shareProfitRs:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i + 5].response,
                    shareProfitRsCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i + 5]
                            .relevanceResponseCRC,
                    shareProfitRsCRCrelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i + 5]
                            .relevanceRemarksCRC,
                    firmAudit: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i + 6].response,
                    firmAuditCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i + 6]
                            .relevanceResponseCRC,
                    firmAuditCRCrelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i + 6]
                            .relevanceRemarksCRC,
                    transferPrice:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i + 7].response,
                    transferPriceCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i + 7]
                            .relevanceResponseCRC,
                    transferPriceCRCrelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i + 7]
                            .relevanceRemarksCRC,
                    balance: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i + 8].response,
                    balanceCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i + 8]
                            .relevanceResponseCRC,
                    balanceCRCrelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[2].subSubQuestions[1].fields[i + 8]
                            .relevanceRemarksCRC,
                };
                tallyYesArr.push(tallyYesArrtemp);
            }
        } else {
            let tallyYesArrtemp = {
                nameFirm: '',
                panNoFirm: '',
                remunRec: '',
                amtInt: '',
                shareProfit: '',
                shareProfitRs: '',
                firmAudit: '',
                transferPrice: '',
                balance: '',
            };
            tallyYesArr.push(tallyYesArrtemp);
        }
        TempPayLoad.tallyYes = tallyYesArr;
        // screen 3 - Tab 4 -capital gain
        let capitalgainArr = [];
        if (apiResponse.checklistJson.checklistL1 && apiResponse.checklistJson.checklistL1.questions[2].subQuestion[3].fields.length > 0) {
            for (let i = 0; i < apiResponse.checklistJson.checklistL1.questions[2].subQuestion[3].fields.length; i += 2) {
                let capitalgainArrtemp = {
                    natureAssets: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[3].fields[i].response,
                    balanceCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[3].fields[i].relevanceResponseCRC,
                    balanceCRCrelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[3].fields[i].relevanceRemarksCRC,
                    natureAssetsUpload: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[3].fields[i + 1].response,
                };
                capitalgainArr.push(capitalgainArrtemp);
            }
        } else {
            let capitalgainArrtemp = {
                natureAssets: '',
                natureAssetsUpload: '',
            };
            capitalgainArr.push(capitalgainArrtemp);
        }
        TempPayLoad.capitalgain = capitalgainArr;

        // screen 3 -Tab 5 - other source
        let dividentArr = [];
        if (
            apiResponse.checklistJson.checklistL1 &&
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[0].fields.length > 0
        ) {
            for (
                let i = 0;
                i < apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[0].fields.length;
                i += 3
            ) {
                let dividenttempArr = {
                    divPayer: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[0].fields[i].response,
                    divPayerCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[0].fields[i].relevanceResponseCRC,
                    divPayerCRCrelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[0].fields[i].relevanceRemarksCRC,
                    divAmount: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[0].fields[i + 1].response,
                    divAmountCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[0].fields[i + 1]
                            .relevanceResponseCRC,
                    divAmountCRCrelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[0].fields[i + 1]
                            .relevanceRemarksCRC,
                    divUpload:
                        apiResponse.checklistJson.checklistL1.questions &&
                        apiResponse.checklistJson.checklistL1.questions[2] &&
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4] &&
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[0] &&
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[0].fields[i + 2] &&
                        apiResponse.checklistJson.checklistL1.questions.checklistJson.checklistL1.questions[2].subQuestion[4]
                            .subSubQuestions[0].fields[i + 2].response,
                };
                dividentArr.push(dividenttempArr);
            }
        } else {
            let dividenttempArr = {
                divPayer: '',
                divAmount: '',
            };
            dividentArr.push(dividenttempArr);
        }
        TempPayLoad.divident = dividentArr;
        let fdArr = [];
        if (
            apiResponse.checklistJson.checklistL1 &&
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[1].fields.length > 0
        ) {
            for (
                let i = 0;
                i < apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[1].fields.length;
                i += 3
            ) {
                let fdtempArr = {
                    fdPayer: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[1].fields[i].response,
                    fdPayerCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[1].fields[i].relevanceResponseCRC,
                    fdPayerCRCrelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[1].fields[i].relevanceRemarksCRC,
                    fdAmount: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[1].fields[i + 1].response,
                    fdAmountCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[1].fields[i + 1]
                            .relevanceResponseCRC,
                    fdAmountCRCrelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[1].fields[i + 1]
                            .relevanceRemarksCRC,
                    fdUpload:
                        apiResponse.checklistJson.checklistL1.questions &&
                        apiResponse.checklistJson.checklistL1.questions[2] &&
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4] &&
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[1] &&
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[1].fields[i + 2] &&
                        apiResponse.checklistJson.checklistL1.questions.checklistJson.checklistL1.questions[2].subQuestion[4]
                            .subSubQuestions[1].fields[i + 2].response,
                };
                fdArr.push(fdtempArr);
            }
        } else {
            let fdtempArr = {
                fdPayer: '',
                fdAmount: '',
            };
            fdArr.push(fdtempArr);
        }
        TempPayLoad.fd = fdArr;
        let othersArr = [];
        if (
            apiResponse.checklistJson.checklistL1 &&
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[2].fields.length > 0
        ) {
            for (
                let i = 0;
                i < apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[2].fields.length;
                i += 3
            ) {
                let othertempArr = {
                    otherPayer: apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[2].fields[i].response,
                    otherPayerCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[2].fields[i].relevanceResponseCRC,
                    otherPayerCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[2].fields[i].relevanceRemarksCRC,
                    otherAmount:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[2].fields[i + 1].response,
                    otherAmountCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[2].fields[i + 1]
                            .relevanceResponseCRC,
                    otherAmountCRCrelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[2].fields[i + 1]
                            .relevanceRemarksCRC,
                    otherUpload:
                        apiResponse.checklistJson.checklistL1.questions &&
                        apiResponse.checklistJson.checklistL1.questions[2] &&
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4] &&
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[2] &&
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[4].subSubQuestions[2].fields[i + 2] &&
                        apiResponse.checklistJson.checklistL1.questions.checklistJson.checklistL1.questions[2].subQuestion[4]
                            .subSubQuestions[2].fields[i + 2].response,
                };
                othersArr.push(othertempArr);
            }
        } else {
            let othertempArr = {
                otherPayer: '',
                otherAmount: '',
            };
            othersArr.push(othertempArr);
        }
        TempPayLoad.othersources = othersArr;

        // screen 3 - Tab 6 - Agri
        TempPayLoad.agricultureName = apiResponse.checklistJson.checklistL1.questions[2].subQuestion[5].fields[0].response;
        TempPayLoad.agricultureNameCRCrelevenceResponse =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[5].fields[0].relevanceResponseCRC;
        TempPayLoad.agricultureNameCRCrelevenceRemarks =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[5].fields[0].relevanceRemarksCRC;
        TempPayLoad.agriAmount = apiResponse.checklistJson.checklistL1.questions[2].subQuestion[5].fields[1].response;
        TempPayLoad.agriAmountCRCrelevenceResponse =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[5].fields[1].relevanceResponseCRC;
        TempPayLoad.agriAmountCRCrelevenceRemarks =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[5].fields[1].relevanceRemarksCRC;
        TempPayLoad.agriReceipt = apiResponse.checklistJson.checklistL1.questions[2].subQuestion[5].fields[2].response;
        TempPayLoad.agriReceiptCRCrelevenceResponse =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[5].fields[2].relevanceResponseCRC;
        TempPayLoad.agriReceiptCRCrelevenceRemarks =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[5].fields[2].relevanceRemarksCRC;
        TempPayLoad.agriExpenses = apiResponse.checklistJson.checklistL1.questions[2].subQuestion[5].fields[3].response;
        TempPayLoad.agriExpensesCRCrelevenceResponse =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[5].fields[3].relevanceResponseCRC;
        TempPayLoad.agriExpensesCRCrelevenceRemarks =
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[5].fields[3].relevanceRemarksCRC;
        //console.log('TempPayLoad:', TempPayLoad);

        let investmentArr1 = [];
        if (
            apiResponse.checklistJson.checklistL1 &&
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[0].fields.length > 0
        ) {
            for (
                let i = 0;
                i < apiResponse.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[0].fields.length;
                i += 2
            ) {
                let investmentArrtemp = {
                    investmentDetails:
                        apiResponse.checklistJson.checklistL1 &&
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[0].fields[i].response,
                    investmentDetailsCRCRelevenceResponse:
                        apiResponse.checklistJson.checklistL1 &&
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[0].fields[i].relevanceResponseCRC,
                    investmentDetailsCRCRelevenceRemarks:
                        apiResponse.checklistJson.checklistL1 &&
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[0].fields[i].relevanceRemarksCRC,
                    investmentAmt:
                        apiResponse.checklistJson.checklistL1 &&
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[0].fields[i + 1].response,
                    investmentAmtCRCRelevenceResponse:
                        apiResponse.checklistJson.checklistL1 &&
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[0].fields[i + 1]
                            .relevanceResponseCRC,
                    investmentAmtCRCRelevenceRemarks:
                        apiResponse.checklistJson.checklistL1 &&
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[0].fields[i + 1]
                            .relevanceRemarksCRC,
                };
                investmentArr1.push(investmentArrtemp);
            }
        } else {
            let investmentArrtemp = {
                investmentDetails: '',
                investmentAmt: '',
            };
            investmentArr1.push(investmentArrtemp);
        }
        TempPayLoad.investment1 = investmentArr1;

        let donationArr1 = [];
        if (
            apiResponse.checklistJson.checklistL1 &&
            apiResponse.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[1].fields.length > 0
        ) {
            for (
                let i = 0;
                i < apiResponse.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[1].fields.length;
                i += 2
            ) {
                let donationArrtemp = {
                    donationDetails:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[1].fields[i].response,
                    donationDetailsCRCRelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[1].fields[i].relevanceResponseCRC,
                    donationDetailsCRCRelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[1].fields[i].relevanceRemarksCRC,
                    donationAmt:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[1].fields[i + 1].response,
                    donationDetailsCRCRelevenceResponse:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[1].fields[i + 1]
                            .relevanceResponseCRC,
                    donationDetailsCRCRelevenceRemarks:
                        apiResponse.checklistJson.checklistL1.questions[2].subQuestion[6].subSubQuestions[1].fields[i + 1]
                            .relevanceRemarksCRC,
                };
                donationArr1.push(donationArrtemp);
            }
        } else {
            let donationArrtemp = {
                donationDetails: '',
                donationAmt: '',
            };
            donationArr1.push(donationArrtemp);
        }
        TempPayLoad.donation1 = donationArr1;
    };

    const handleTabChange = (name) => {
        // console.log('aaaaaaaaa', name)
        if (name === 'salary') {
            userType.salaryInitializeFlag = true;
        }
        if (name === 'house property') {
            userType.houseInitializeFlag = true;
        }
        if (name === 'business') {
            userType.businessInitializeFlag = true;
        }
        if (name === 'capital') {
            userType.capitalInitializeFlag = true;
        }
        if (name === 'other') {
            userType.otherInitializeFlag = true;
        }
        if (name === 'agriculture') {
            userType.agricultureInitializeFlag = true;
        }
        if (name === 'deduction') {
            userType.donationInitializeFlag = true;
        }
    };

    //console.log("Itec Open " , itecOpen);
    return (
        <>
            {showLoader ? <LoaderPopUp showLoader={showLoader} /> : null}

            <div className="w100 tab-panel">
                <AppBar position="static" color="default" className="custom-tab">
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="scrollable auto tabs example"
                    >
                        <Tab label="Salary" onClick={() => handleTabChange('salary')} {...a11yProps(0)} />
                        <Tab label="House Property" onClick={() => handleTabChange('house property')} {...a11yProps(1)} />
                        <Tab label="Business or Profession" onClick={() => handleTabChange('business')} {...a11yProps(2)} />
                        <Tab label="Capital Gain" onClick={() => handleTabChange('capital')} {...a11yProps(3)} />
                        <Tab label="Other Sources" onClick={() => handleTabChange('other')} {...a11yProps(4)} />
                        <Tab label="Agricultural Income" onClick={() => handleTabChange('agriculture')} {...a11yProps(5)} />
                        {salaryradiodata === 'No' ? (
                            <Tab label="Deductions" onClick={() => handleTabChange('deduction')} {...a11yProps(6)} />
                        ) : (
                            ''
                        )}
                    </Tabs>
                </AppBar>
                <TabPanel value={value} index={0} className="each-tab">
                    <CRSalaryDifference
                        apiResponse={apiResponse}
                        handleRelevence={handleRelevence}
                        classes={classes}
                        StyledRadio={StyledRadio}
                    />
                </TabPanel>
                <TabPanel value={value} index={1} className="each-tab">
                    <CRCHouseproperty
                        apiResponse={apiResponse}
                        handleRelevence={handleRelevence}
                        classes={classes}
                        StyledRadio={StyledRadio}
                    />
                </TabPanel>
                <TabPanel value={value} index={2} className="each-tab">
                    <CRCBusiness apiResponse={apiResponse} handleRelevence={handleRelevence} classes={classes} StyledRadio={StyledRadio} />
                </TabPanel>
                <TabPanel value={value} index={3} className="each-tab">
                    <CRCCapitalgain
                        apiResponse={apiResponse}
                        handleRelevence={handleRelevence}
                        classes={classes}
                        StyledRadio={StyledRadio}
                    />
                </TabPanel>
                <TabPanel value={value} index={4} className="divident-income each-tab">
                    <CRCOthersources
                        apiResponse={apiResponse}
                        handleRelevence={handleRelevence}
                        classes={classes}
                        StyledRadio={StyledRadio}
                    />
                </TabPanel>
                <TabPanel value={value} index={5} className="each-tab">
                    <CRCAgricultureIncome
                        apiResponse={apiResponse}
                        handleRelevence={handleRelevence}
                        classes={classes}
                        StyledRadio={StyledRadio}
                    />
                </TabPanel>
                {salaryradiodata === 'No' ? (
                    <TabPanel value={value} index={6} className="each-tab">
                        <CRCDonations
                            apiResponse={apiResponse}
                            handleRelevence={handleRelevence}
                            classes={classes}
                            StyledRadio={StyledRadio}
                        />
                    </TabPanel>
                ) : (
                    ''
                )}
            </div>
            {itecOpen && (
                <CrcDialog
                    itecOpen={itecOpen}
                    updateCRCRelevance={updateCRCRelevance}
                    handleItecClose={handleItecClose}
                    crcCategory={category}
                    crcRemarks={remarks}
                />
            )}
        </>
    );
}
